import client, { getRequestHeaders } from '@/shared/api';
import { END_ACTIVITY_LOG, HEARTBEAT, LOGOUT_LOG, RELYING_PARTY_NAVIGATE, START_ACTIVITY_LOG } from '@/shared/api/graphql/activityLog';
import Config from '@/shared/config/config';
import { print } from 'graphql';

export const startTrackingMedTaskActivity = async ({ truentityId }: { truentityId: string }) => {
  try {
    const result = await client.mutate({
      mutation: START_ACTIVITY_LOG,
      variables: { truentityId }
    });

    return result.data.startMedTasksActivity.activityLog;
  } catch (error) {
    console.error(error);
  }

  return null;
};

export const stopTrackingMedTaskActivity = async ({ activityLogId }: { activityLogId: string }) => {
  try {
    const result = await client.mutate({
      mutation: END_ACTIVITY_LOG,
      variables: { activityLogId }
    });

    return result.data.endMedTasksActivity;
  } catch (error) {
    console.error(error);
  }

  return null;
};

export const stopTrackingMedTaskActivityOnUnload = ({ activityLogId }: { activityLogId: string }) => {
  if (!Config.GRAPHQL_ENDPOINT) return;

  fetch(Config.GRAPHQL_ENDPOINT, {
    method: 'POST',
    keepalive: true,
    headers: { 'Content-Type': 'application/json', ...getRequestHeaders().customHeaders },
    body: JSON.stringify({ operationName: 'EndMedTasksActivity', query: print(END_ACTIVITY_LOG), variables: { activityLogId } })
  }).catch(() => undefined);
};

export const trackLogout = async ({ timedOut }: { timedOut: boolean }) => {
  try {
    const result = await client.mutate({
      mutation: LOGOUT_LOG,
      variables: { timedOut }
    });

    return result.data.relyingPartyLogout.status;
  } catch (error) {
    console.error(error);
  }

  return null;
};

export type ActivityLog = {
  id: string;
  logText: string;
  activityType: string;
  activityTime: Date;
  activityEndTime: Date;
  timeTakenSecs: number;
};

export const trackNavigation = async ({
  navigateTo,
  prevActivityLogId,
  truentityId
}: {
  navigateTo: string;
  prevActivityLogId: string;
  truentityId?: string;
}): Promise<ActivityLog | null> => {
  try {
    const result = await client.mutate({
      mutation: RELYING_PARTY_NAVIGATE,
      variables: { navigateTo, prevActivityLogId, truentityId }
    });

    return result.data.relyingPartyAdminNavigate.activityLog;
  } catch (error) {
    console.error(error);
  }

  return null;
};

export const sendHeartbeat = async ({
  patientId,
  userActive,
  tabId
}: {
  patientId?: string;
  userActive: boolean;
  tabId?: string;
}): Promise<string | null> => {
  try {
    const result = await client.mutate<{ relyingPartyAdminHeartbeat: { status: string } }>({
      mutation: HEARTBEAT,
      variables: { patientId, userActive, tabId }
    });

    return result.data?.relyingPartyAdminHeartbeat.status ?? null;
  } catch (error) {
    console.error(error);
  }

  return null;
};
